import React from 'react'

import { BASE_URL, ICONS } from '../../constants'

import { useSelectedIncident } from '../hooks'
import { useCrimeCategory } from '../../crimeCategories/hooks'

import IncidentDate from './IncidentDate'

import styles from './IncidentDetails.module.css'

const IncidentDetailsHeader = () => {
  const incident = useSelectedIncident()
  const category = useCrimeCategory(incident && incident.crimeCategory)

  if (!incident) return null

  const { incidentTypeDescription, location, incidentDate } = incident

  return (
    <div className={styles.header}>
      <img
        src={BASE_URL + ICONS.BORDERLESS.DIR + category.icon}
        alt={category.name}
        className={styles.headerIcon}
      />
      <div className={styles.headerTitle}>{incidentTypeDescription}</div>
      <div className={styles.headerStreet}>{location}</div>
      <IncidentDate style={styles.headerMeta} date={incidentDate} />
    </div>
  )
}
export default IncidentDetailsHeader
